"use client";

import { usePathname } from "next/navigation";
import { Navbar } from "./nav";

export function NavWrapper() {
  const pathname = usePathname();
  const showNavbar =
    !pathname.split("/").includes("download") &&
    !pathname.split("/").includes("refer");
  return <>{showNavbar && false && <Navbar />}</>;
}
